import { TranslatePipe } from "@ngx-translate/core";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ComponentAdapterCounterGas } from "src/components/shared-components/class/adapters/component-adapter-counter-gas";
import { GenericCounterGraphData } from "src/components/shared-components/class/generic-counter-graph-data";
import { WidgetCounterParent } from "src/components/shared-components/class/widget-counter-parent";
import { GasCounterMeasurementType } from "src/components/shared-components/enum/enumCounterMeasurementType";
import { ChartSerieKind } from "src/components/shared-components/enum/enumChart";
import { SkillNameList } from "src/components/shared-components/enum/enumSkillNameList";
import { SmartComponentSummaryData } from "src/components/shared-components/class/smart-components/smart-component-property-details";
import { WidgetCounterSkillExpandableComponent } from "../../widget-counter-skill-expandable/widget-counter-skill-expandable.component";
import { WidgetCounterBandComponent } from "../../widget-counter-band/widget-counter-band.component";
import { WidgetCounterBandTripleComponent } from "../../widget-counter-band-triple/widget-counter-band-triple.component";

@Component({
    selector: "app-counter-gas-meter",
    templateUrl: "./counter-gas-meter.component.html",
    styleUrls: ["./counter-gas-meter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [WidgetCounterSkillExpandableComponent, WidgetCounterBandComponent, WidgetCounterBandTripleComponent, TranslatePipe]
})
export class CounterGasMeterComponent extends WidgetCounterParent<ComponentAdapterCounterGas> {
  public chartSerieKind = ChartSerieKind;
  public showBandVolume: boolean = false;
  public umVolume: string = "";
  public chartBarVolume: GenericCounterGraphData =
    new GenericCounterGraphData();
  public chartBarVolumeCSV: string = "";

  public previousMonthValue: string = "";
  public previousyearValue: string = "";
  public currentyearValue: string = "";
  public gasVolumePreviousMonth: string = "";
  public gasVolumeCurrentMonth: string = "";
  public gasVolumePreviousYear: string = "";
  public gasVolumeCurrentYear: string = "";
  public errorChartVolume: boolean = false;
  public skillType = SkillNameList;
  @Input() public headerSummary: SmartComponentSummaryData = null;

  protected async onComponentLoad(): Promise<void> {
    this.setMeasurements();

    try {
      await this._loaderService.presentLoaderWaiting();

      if (this.componentAdapter.Volume) {
        this.umVolume = this.componentAdapter.Volume.measureUnit;
        this.showBandVolume = true;
        try {
          if (this.componentAdapter.Summary) {
            this.chartBarVolume =
              await this.getSummaryYearlyForMonthConsumption(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_GAS_VOLUME
              );
            this.chartBarVolume = this.roundChartData(
              this.chartBarVolume,
              true
            );
            if (this.chartBarVolume.data.length === 0) {
              this.showBandVolume = false;
            }
            this.chartBarVolumeCSV =
              await this.getSummaryYearlyForMonthConsumptionCSV(
                this.componentAdapter.IdEnvironment,
                this.componentAdapter.IdSmartComponentKind,
                SkillNameList.COUNTER_GAS_VOLUME
              );
          } else {
            this.chartBarVolume = await this.getYearlyForMonthConsumption(
              this.componentAdapter.Volume.address,
              this.componentAdapter.Volume.instanceGUID
            );
            this.chartBarVolume = this.roundChartData(
              this.chartBarVolume,
              true
            );

            this.chartBarVolumeCSV = await this.getYearlyForMonthConsumptionCSV(
              this.componentAdapter.Volume.address,
              this.componentAdapter.Volume.instanceGUID
            );
          }
        } catch {
          this.errorChartVolume = true;
        }
      }
    } finally {
      await this._loaderService.dismissLoaderWaiting();
    }
  }
  protected onComponentDestroy(): void {}

  /**
   * This method set the displayed data defined throught the current "Measurements" associated to the
   * SmartComponent associated to this Widget.
   */
  private setMeasurements(): void {
    this.previousMonthValue = this.componentAdapter.PreviousMonth;
    this.previousyearValue =
      this._translateService.instant("dictionary.year") + " " + this.componentAdapter.PreviousYear;
    this.currentyearValue =
      this._translateService.instant("dictionary.year") + " " + this.componentAdapter.CurrentYear;

    this.gasVolumePreviousMonth =
      this.componentAdapter.MeasurementMap.get(
        GasCounterMeasurementType[
          GasCounterMeasurementType.GAS_VOLUME_PREVIOUS_MONTH
        ]
      ) || "---";
    this.gasVolumeCurrentMonth =
      this.componentAdapter.MeasurementMap.get(
        GasCounterMeasurementType[
          GasCounterMeasurementType.GAS_VOLUME_LAST_MONTH
        ]
      ) || "---";
    this.gasVolumePreviousYear =
      this.componentAdapter.MeasurementMap.get(
        GasCounterMeasurementType[
          GasCounterMeasurementType.GAS_VOLUME_PREVIOUS_YEAR
        ]
      ) || "---";
    this.gasVolumeCurrentYear =
      this.componentAdapter.MeasurementMap.get(
        GasCounterMeasurementType[
          GasCounterMeasurementType.GAS_VOLUME_LAST_YEAR
        ]
      ) || "---";
  }
}
